export const questionType = [
  {
    label: '单选题',
    value: 1
  },
  {
    label: '多选题',
    value: 2
  },
  {
    label: '单选投票题',
    value: 3
  },
  {
    label: '单项填空题',
    value: 4
  },
  {
    label: '多项填空题',
    value: 5
  },
  {
    label: '打分题',
    value: 6
  },
  {
    label: '地址',
    value: 7
  },
  {
    label: '上传附件',
    value: 8
  },
  {
    label: '上传pdf',
    value: 9
  },
  {
    label: '上传word',
    value: 10
  },
  {
    label: '上传excel',
    value: 11
  },
  {
    label: '上传ppt',
    value: 12
  },
  {
    label: '上传图片',
    value: 13
  },
  {
    label: '时间题',
    value: 14
  },
  {
    label: '月度题',
    value: 15
  },
  {
    label: '定位题',
    value: 16
  }
];
